import { render, staticRenderFns } from "./brDevIndex.vue?vue&type=template&id=73c3ceef&scoped=true"
import script from "./brDevIndex.vue?vue&type=script&lang=js"
export * from "./brDevIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c3ceef",
  null
  
)

export default component.exports